import { useConnection, useSwitchChain as useSwitchChainWagmi } from 'wagmi';
import { useAppDispatch } from 'store/hooks';
import { selectChain } from 'store/features/chain/chainActions';
import { NetworkChainIds } from '@dapp/multi-lib/network';
import { useCallback } from 'react';

interface UseSwitchNetworkParams {
  chainId: number;
}

export const useSwitchNetwork = () => {
  const {
    switchChainAsync: switchNetworkAsyncOriginal,
    switchChain: switchNetworkOriginal,
    ...rest
  } = useSwitchChainWagmi();
  const connection = useConnection();
  const dispatch = useAppDispatch();

  const switchNetworkAsync = useCallback(
    async (params: UseSwitchNetworkParams) => {
      const { chainId } = params;
      if (chainId === connection.chainId) return;

      await switchNetworkAsyncOriginal?.({ chainId: chainId });
      dispatch(
        selectChain({
          newChainId: chainId as NetworkChainIds,
          currentChainId: connection.chainId as NetworkChainIds,
        })
      );
    },
    [switchNetworkAsyncOriginal, dispatch, connection.chainId]
  );

  const switchNetwork = useCallback(
    (params: UseSwitchNetworkParams) => {
      const { chainId } = params;
      switchNetworkOriginal?.({ chainId: chainId });
      dispatch(
        selectChain({
          newChainId: chainId as NetworkChainIds,
          currentChainId: connection.chainId as NetworkChainIds,
        })
      );
    },
    [switchNetworkOriginal, dispatch, connection.chainId]
  );

  return {
    ...rest,
    switchNetworkAsync,
    switchNetwork,
  };
};
